import React from 'react'
import { CardFrame } from '../../../ui/CardFrame/CardFrame.jsx'
import { WeekRatingWeatherScale } from '../interactions/WeekRatingWeatherScale.jsx'
import { CardHistoryBack } from '../interactions/CardHistoryBack.jsx'
import { useCardHistory } from '../interactions/useCardHistory.js'

const CARD_DEF = { id: 'prep-week-rating', icon: '★', label: 'Week rating' }

/**
 * WeekRatingCard — 1–5 star weather scale + optional 'why' textarea.
 * catalog #14, prep-week-rating.
 * Reuses WeekRatingWeatherScale; adds 'why' free-text field.
 *
 * Copy-decisions §open-items: "why" placeholder pending copywriter confirmation.
 * Using suggested placeholder: "Anything behind the rating…"
 */
export function WeekRatingCard({ card, value, onChange, disabled, ownerUserId }) {
  const { data: historyData, loading: historyLoading, error: historyError } = useCardHistory(card?.prepCardId ?? 'prep-week-rating', ownerUserId)

  const back = (
    <CardHistoryBack
      cardDef={CARD_DEF}
      entries={historyData?.entries ?? []}
      loading={historyLoading}
      error={historyError}
      onFlip={() => {}}
    />
  )

  const ratingValue = value?.value != null ? value : null
  const why = value?.why ?? ''

  function handleRatingChange(newRating) {
    onChange({ ...newRating, why })
  }

  function handleWhyChange(e) {
    onChange({ ...(value ?? {}), why: e.target.value })
  }

  return (
    <CardFrame
      kind="prep"
      icon="★"
      iconClass="mustard"
      title="Week rating"
      prompt="How was this week?"
      state={disabled ? 'locked' : ratingValue != null ? 'filled' : 'empty'}
      back={back}
      data-testid="prep-card-prep-week-rating"
      className="prepcard"
    >
      <WeekRatingWeatherScale value={ratingValue} onChange={handleRatingChange} disabled={disabled} />
      {(ratingValue != null || why) && (
        <div style={styles.whyWrap}>
          <textarea
            rows={1}
            value={why}
            placeholder={disabled ? '' : 'Anything behind the rating…'}
            disabled={disabled}
            onChange={handleWhyChange}
            style={styles.whyInput}
            aria-label="Why — optional context"
          />
        </div>
      )}
    </CardFrame>
  )
}

const styles = {
  whyWrap: { padding: '0 14px 12px' },
  whyInput: {
    width: '100%', border: 'none', borderBottom: '1px solid var(--color-line)',
    outline: 'none', background: 'transparent', fontSize: 12,
    color: 'var(--color-text-secondary)', fontFamily: 'inherit', padding: '2px 0',
    resize: 'none', overflow: 'hidden', lineHeight: 1.5,
  },
}
